angular.module('rjmNg.directives').directive "connectionPicker", [
  "$url"
  ($url) ->
    restrict: "E"
    templateUrl: 'directive.connectionPicker.html'
    replace: true
    scope: {}
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$routeParams"
      "appRoute"
      "$clientUrl"
      "$q"
      "logger"
      "app"
      "IntegrationTypes"
      "connectionUtils"
      "$modal"
      "Clients"
      "FEATURE_TIER"
      "InputConnections"
      "$location"
      "$scope"
      "$window"
      (
        $routeParams
        appRoute
        $clientUrl
        $q
        logger
        app
        IntegrationTypes
        connectionUtils
        $modal
        Clients
        FEATURE_TIER
        InputConnections
        $location
        $scope
        $window
      ) ->

        view = @

        view.allConnections = []
        isClientImplemented = true # to prevent flashing view on page load to clients who are implemented
        view.isEssentialAccount = true
        clientId = $routeParams.clientId
        InputConnectionsInstance = InputConnections(clientId)

        view.isLoading = true
        ## view urls
        view.connectionsUrl = appRoute "/settings/connection"

        $q.all([
          Clients.get(clientId)
          IntegrationTypes(clientId).getAllForClient()
          InputConnectionsInstance.get()
        ]).then ([client, integrationTypes, connections]) ->
          view.allConnections = connections
          isClientImplemented = client.properties.is_implemented
          view.isEssentialAccount = client.properties.feature_tier is FEATURE_TIER.BASIC.toString()
          view.integrationTypes = integrationTypes.reduce((cloudBiIntegrations, integration) -> 
            if integration.cbi_is_available then cloudBiIntegrations.push(integration)
            cloudBiIntegrations
          , [])
          view.integrationTypes.map((integration) ->
            connectionUtils.mergeUIConfig(integration)
            integration.hasAccess = _isIntegrationAccessible(integration)
            integration.url = _createUrl(integration)
          )
          view.isLoading = false

        _createUrl = (integration) ->
          switch integration.type
            when 'userpush' then $url "/settings/#{clientId}/upload/"
            when 'googleAdwords'
              $clientUrl '/google/authorize?feature=AdWords'
            when 'googleAnalytics'
              $clientUrl '/google/authorize?feature=Analytics'
            when 'googleEcommerce'
              $clientUrl '/google/authorize?feature=Ecommerce'
            when 'google_analytics4_live'
              $clientUrl '/google/authorize?feature=Analytics4Live'
            else appRoute "/settings/connection/create/#{integration.route}/"

        _isIntegrationAccessible = (integration) ->
          # Adobe Commerce Intelligence Essentials Account
          if view.isEssentialAccount
            if integration.type is 'googleAnalytics'
              !view.allConnections.some (connection) ->
                connection.type is 'google_analytics'
            else if integration.type is 'google_analytics4_live'
              !view.allConnections.some (connection) ->
                connection.type is 'google_analytics4_live'
            else
              false
          # Adobe Commerce Intelligence Pro Account
          else
            switch integration.type
              when 'push_api'
                true
              when 'userpush'
                isClientImplemented
              when 'mysql', 'mongo', 'postgres', 'mssql', 'redshift'
                not isClientImplemented or !!app.hasFeatureFlag integration.uiFeatureFlag
              else !!app.hasFeatureFlag integration.uiFeatureFlag

        _requestIntegrationModal = (integration) ->
          modalScope = $scope.$new()
          modalScope.integration = integration
          modalScope.requestIntegrationViaIntercom = ->
            Intercom("showNewMessage", "I'd like to add the #{integration.display_name} integration to my account!")

          modal = $modal(
            template: "modal.requestIntegration.html",
            show: true,
            backdrop: 'static'
            keyboard: false
            scope: modalScope
          )

        _logButtonClick = (integrationType) ->
          type = 'Connections Page Usage'
          key = "#{integrationType} button clicked"
          value = 1
          action = 'open'

          logger.log(type, key, value, action)

        view.clickedIntegration = (integration) ->
          if integration.hasAccess
            switch integration.type
              when 'userpush', 'googleAdwords', 'googleAnalytics', 'googleEcommerce', 'google_analytics4_live'
                $window.location = integration.url
                true
              else
                $location.path(integration.url)
          else
            _logButtonClick(integration)
            _requestIntegrationModal(integration)

        view.upgradeToPro = () ->
          Intercom("showNewMessage", "I'm interested in upgrading to Adobe Commerce Intelligence Pro.")

        view
    ]
    link: (scope, element, attributes, rjmUi) ->

      scope.$watch "view.isLoading", (newVal, oldVal) ->
        rjmUi?.loadingUi "connection-picker", newVal, "Loading available integrations"
]
